import { HandleTextChange, HandleSelectChange, HandleCheckChange, CallAPI, GetCookieFunction, AgeToBirthday, BirthdayToAge } from '../../utils/util';
import React, { Component } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class EditPersonalProfile extends Component {
    constructor(props) {
        super(props);
        this.patientId = parseInt(this.props.router.params.patientId);
        this.userType = GetCookieFunction("User").type;
        this.isAdmin = GetCookieFunction("User").admin === 1 || this.userType === "executive" || this.userType === "centeradmin";
        this.state = {
            "fName": "",
            "lName": "",
            "gender": "MALE",
            "pNum": "",
            "email": "",
            "bDay": "",
            "address1": "",
            "address2": "",
            "city": "",
            "district": "",
            "City_District_Id": null,
            "timezone": "Asia/Dhaka",
            "centerID": "",
            "active": false,
            "centers": [],
            "modalVariant": "",
            "modalMessage": "",
            "loading": true,
            "citySuggestions": [],
            "showCitySuggestions": false,
            "showAddCityModal": false,
            "newLocation": { city: '', district: '' },
            "addCityModalError": "",
            // Age is the user-facing field. We keep the originally-loaded DOB so that
            // saving with an unchanged age doesn't overwrite a real birthday.
            "age": "",
            "originalBDay": ""
        };

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.selectLocation = this.selectLocation.bind(this);

        // Is this page being accessed in funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
    }

    componentDidMount() {
        // Fetch current patient full basic info (includes all address fields, email, timezone)
        CallAPI({}, `patients/${this.patientId}/complete`, 'GET', (res) => {
            // Format the date for the input (API returns ISO date like "1990-03-25T00:00:00.000Z")
            let bDay = "";
            if (res.bDay) {
                const d = new Date(res.bDay);
                const year = d.getUTCFullYear();
                const month = String(d.getUTCMonth() + 1).padStart(2, '0');
                const day = String(d.getUTCDate()).padStart(2, '0');
                bDay = `${year}-${month}-${day}`;
            }

            this.setState({
                "fName": res.fName || "",
                "lName": res.lName || "",
                "gender": res.gender || "MALE",
                "pNum": res.pNum || "",
                "email": res.email || "",
                "bDay": bDay,
                "originalBDay": bDay,
                "age": BirthdayToAge(bDay),
                "address1": res.address1 || "",
                "address2": res.address2 || "",
                "city": res.city || "",
                "district": res.district || "",
                "City_District_Id": res.City_District_Id || null,
                "timezone": res.timezone || "Asia/Dhaka",
                "centerID": res.centerID ? String(res.centerID) : "",
                "active": res.active || false,
                "loading": false
            });
        }, (err) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Failed to load patient information.",
                "loading": false
            });
        });

        // Fetch centers list for admin users
        if (this.isAdmin) {
            CallAPI({}, 'centers/list', 'GET', (res) => {
                this.setState({ "centers": res || [] });
            });
        }
    }

    handleCityChange(e) {
        const value = e.target.value;
        this.setState({ "city": value });

        if (value.length >= 2) {
            CallAPI({}, `cityDistricts?search=${encodeURIComponent(value)}`, 'GET', (res) => {
                this.setState({
                    "citySuggestions": res.data || [],
                    "showCitySuggestions": true
                });
            });
        } else {
            this.setState({ "citySuggestions": [], "showCitySuggestions": false, "district": "", "City_District_Id": null });
        }
    }

    selectLocation(location) {
        this.setState({
            "City_District_Id": location.id,
            "city": location.city,
            "district": location.district,
            "citySuggestions": [],
            "showCitySuggestions": false
        });
    }

    handleAgeChange = (e) => {
        this.setState({ age: e.target.value });
    }

    // Keep the original DOB if the age on save matches the age it was loaded with
    // (even if the user edited and then reverted it). Otherwise derive a new DOB
    // anchored to Jan 1. A blank/invalid age never clears an existing birthday.
    getBirthdayForSave() {
        const originalAge = BirthdayToAge(this.state.originalBDay);
        if (String(this.state.age) === String(originalAge)) {
            return this.state.originalBDay;
        }
        const derived = AgeToBirthday(this.state.age);
        return derived || this.state.originalBDay;
    }

    openAddCityModal = () => {
        this.setState({
            showAddCityModal: true,
            showCitySuggestions: false,
            newLocation: { city: this.state.city, district: '' },
            addCityModalError: ''
        });
    }

    closeAddCityModal = () => {
        this.setState({ showAddCityModal: false, addCityModalError: '' });
    }

    handleNewLocationChange = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            newLocation: { ...prev.newLocation, [name]: value }
        }));
    }

    saveNewLocation = (e) => {
        e.preventDefault();
        const { city, district } = this.state.newLocation;

        CallAPI({ city, district }, 'cityDistricts', 'POST', (res) => {
            if (res.success) {
                this.setState({
                    showAddCityModal: false,
                    addCityModalError: '',
                    City_District_Id: res.data.id,
                    city: res.data.city,
                    district: res.data.district
                });
            } else {
                this.setState({ addCityModalError: res.message || "This city/district already exists" });
            }
        }, () => {
            this.setState({ addCityModalError: "Failed to save. Please try again." });
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        const payload = {
            fName: this.state.fName,
            lName: this.state.lName,
            gender: this.state.gender,
            pNum: this.state.pNum,
            email: this.state.email,
            bDay: this.getBirthdayForSave(),
            address1: this.state.address1,
            address2: this.state.address2,
            City_District_Id: this.state.City_District_Id,
            timezone: this.state.timezone
        };

        // Include admin-only fields if user has admin access
        if (this.isAdmin) {
            payload.centerID = this.state.centerID;
            payload.active = this.state.active;
        }

        CallAPI(payload, `patients/${this.patientId}/basic`, 'PUT', (res) => {
            if (res && res.length > 0 && res[0].success) {
                if (this.funnel) {
                    this.props.router.navigate(`/patients/${this.patientId}/patientInfo${this.funnel}`);
                } else {
                    this.setState({
                        "modalVariant": "success",
                        "modalMessage": "Personal profile updated successfully."
                    });
                }
            } else {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "Failed to update profile" + (res[0]?.message ? ": " + res[0].message : "")
                });
            }
        }, (err) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Failed to update profile."
            });
        });
    }

    render() {
        if (this.state.loading) {
            return (
                <div>
                    <PatientNav patientId={this.patientId} />
                    <div className="ci-page">
                        <div className="ci-header"><h2>Loading...</h2></div>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <PatientNav patientId={this.patientId} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.patientId} currentStep={0} />}
                    <div className="ci-header">
                        <h2>Edit Personal Profile</h2>
                        <p>Update the patient's personal and contact information</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        {this.isAdmin && (
                            <>
                                <div className="ci-section-title">Patient Status</div>
                                <div className="ci-card">
                                    <div className="ci-grid ci-grid-2">
                                        <div className="ci-field">
                                            <label htmlFor="centerID">Current Center</label>
                                            <select id="centerID" name="centerID"
                                                value={this.state.centerID}
                                                onChange={(e) => this.handleSelectChange(e)}>
                                                <option value="">-- Select Center --</option>
                                                {this.state.centers.map(c => (
                                                    <option key={c.centerID} value={c.centerID}>{c.centerName}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="ci-field ci-field-vcenter">
                                            <label className="ci-checkbox-label">
                                                <input type="checkbox" name="active"
                                                    checked={this.state.active}
                                                    onChange={(e) => this.handleCheckChange(e)} />
                                                <span>Patient Account Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="ci-section-title">Personal Details</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="fName" className="ci-required-label">First Name</label>
                                    <input type="text" id="fName" name="fName" required maxLength="32"
                                        placeholder="First name"
                                        value={this.state.fName}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="lName" className="ci-required-label">Last Name</label>
                                    <input type="text" id="lName" name="lName" required maxLength="32"
                                        placeholder="Last name"
                                        value={this.state.lName}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="gender" className="ci-required-label">Gender</label>
                                    <select id="gender" name="gender" required
                                        value={this.state.gender}
                                        onChange={(e) => this.handleSelectChange(e)}>
                                        <option value="MALE">Male</option>
                                        <option value="FEMALE">Female</option>
                                        <option value="OTHER">Other</option>
                                    </select>
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="age" className="ci-required-label">Age (years)</label>
                                    <input type="number" id="age" name="age" required
                                        min="0" max="150" step="1"
                                        placeholder="e.g. 55"
                                        value={this.state.age}
                                        onChange={(e) => this.handleAgeChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="timezone" className="ci-required-label">Time Zone</label>
                                    <select id="timezone" name="timezone" required
                                        value={this.state.timezone}
                                        onChange={(e) => this.handleSelectChange(e)}>
                                        <option value="Asia/Dhaka">Asia/Dhaka</option>
                                        <option value="America/Los_Angeles">America/Los Angeles</option>
                                        <option value="America/Phoenix">America/Phoenix</option>
                                        <option value="America/Denver">America/Denver</option>
                                        <option value="America/New_York">America/New York</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="ci-section-title">Contact Information</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="pNum" className="ci-required-label">Phone Number</label>
                                    <input type="tel" id="pNum" name="pNum" required
                                        pattern="^\+?[\d\s\(\)\-]+\d{4}$" maxLength="20"
                                        title="e.g. 01054 694200 or +880 1054 694200"
                                        placeholder="e.g. 01054 694200"
                                        value={this.state.pNum}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" name="email"
                                        placeholder="email@example.com"
                                        value={this.state.email}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-section-title">Address</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="address1" className="ci-required-label">Address Line 1</label>
                                    <input type="text" id="address1" name="address1" required maxLength="100"
                                        placeholder="Street address"
                                        value={this.state.address1}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="address2">Address Line 2</label>
                                    <input type="text" id="address2" name="address2" maxLength="100"
                                        placeholder="Apt, suite, etc. (optional)"
                                        value={this.state.address2}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field ci-field-autocomplete">
                                    <label htmlFor="city">City</label>
                                    <input type="text" id="city" name="city" maxLength="32"
                                        placeholder="City"
                                        autoComplete="off"
                                        value={this.state.city}
                                        onChange={(e) => this.handleCityChange(e)}
                                        onBlur={() => setTimeout(() => this.setState({ showCitySuggestions: false }), 200)} />
                                    {this.state.showCitySuggestions && (
                                        <ul className="ci-autocomplete-list">
                                            {this.state.citySuggestions.length > 0 ? (
                                                this.state.citySuggestions.map((loc) => (
                                                    <li key={loc.id} className="ci-autocomplete-item"
                                                        onMouseDown={() => this.selectLocation(loc)}>
                                                        {loc.city} — {loc.district}
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="ci-autocomplete-item ci-autocomplete-add"
                                                    onMouseDown={this.openAddCityModal}>
                                                    + Add new city/district
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="district">District</label>
                                    <input type="text" id="district" name="district" maxLength="32"
                                        placeholder="District"
                                        value={this.state.district}
                                        readOnly />
                                </div>
                            </div>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Changes</button>
                            <button type="button" className="ci-cancel-btn"
                                onClick={() => this.props.router.navigate(`/patients/${this.patientId}/profile`)}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>

                {/* ── Add City/District Modal ── */}
                {this.state.showAddCityModal && (
                    <div className="ci-modal-overlay" onClick={this.closeAddCityModal}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Add New City/District</h3>
                            {this.state.addCityModalError ? (
                                <div>
                                    <p className="ci-modal-error">{this.state.addCityModalError}</p>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Close">✕</button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.saveNewLocation}>
                                    <div className="ci-field">
                                        <label>City</label>
                                        <input type="text" name="city" required maxLength="45"
                                            value={this.state.newLocation.city}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label>District</label>
                                        <input type="text" name="district" required maxLength="45"
                                            value={this.state.newLocation.district}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Cancel">✕</button>
                                        <button type="submit" className="ci-modal-icon-btn ci-modal-save" title="Save">✓</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                )}

            </div>
        );
    }
}

export default withRouter(EditPersonalProfile);
